(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-main"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('[data-faq-item]');
      this.onClick = (event) => {
        const button = event.target.closest('[data-faq-button]');
        if (!button || button.closest('faq-accordion') !== this) return;
        const item = button.closest('[data-faq-item]');
        this.toggleItem(item, !item.classList.contains('active'));
      };
      this.onBlockSelect = (event) => {
        const item = event.target.closest('[data-faq-item]');
        if (item && this.contains(item)) this.toggleItem(item, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    toggleItem(selectedItem, open) {
      this.items.forEach((item) => {
        const isActive = item === selectedItem && open;
        const button = item.querySelector('[data-faq-button]');
        const answer = item.querySelector('[data-faq-answer]');
        item.classList.toggle('active', isActive);
        button.setAttribute('aria-expanded', String(isActive));
        answer.style.maxHeight = isActive ? answer.scrollHeight + 'px' : null;
      });
    }
  }

  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = true;
      
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always apply the sticky class immediately
      this.header.classList.add('shopify-section-header-sticky');
      // Always show it (remove hidden class if it were present)
      this.header.classList.remove('shopify-section-header-hidden');

      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      }
      
      this.currentScrollTop = scrollTop;
    }
    
    // The hide, reveal, and reset methods are no longer needed for always sticky
    // but the following are good to keep for consistency/future use if needed.
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // Added a check before closing to prevent errors if searchModal is null
      if (this.searchModal) { 
          this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
